<ng-container *transloco="let t">
  @if (showNotificationMessage$ | async) {
    <div class="notification-info">
      <span
        ><lib-icon name="bell" size="x-small" class="me-1"></lib-icon>
        <span [innerHtml]="t('notification_message')"></span
      ></span>
    </div>
  }
</ng-container>
